import React, { useState, useEffect } from "react";
import "./footer.css";
import logo from "../../assets/conectalm.png";

export default function Footer() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  // Efeito para mostrar/ocultar botão "Voltar ao topo"
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleWhatsAppClick = () => {
    window.open("https://wa.me/5598986064394", "_blank");
  };

  const handleInstagramClick = () => {
    window.open(
      "https://www.instagram.com/lmconecta_?igsh=c2RvbGRpemU1MGk0",
      "_blank",
    );
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="footer-section">
        {/* OVERLAY GRADIENTE */}
        <div className="footer-overlay"></div>

        <div className="footer-container">
          <div className="footer-grid">
            {/* COLUNA 1: LOGO E DESCRIÇÃO */}
            <div className="footer-logo-col">
              <div className="footer-logo">
                <img
                  src={logo}
                  alt="Conecta LM Logo"
                  className="footer-logo-img"
                />
              </div>

              <p className="footer-descricao">
                Transformamos ideias em realidade digital. Desenvolvimento web,
                design e marketing digital para impulsionar seu negócio em São
                Luís e todo o Brasil.
              </p>

              <div className="footer-social">
                <a
                  href="https://www.instagram.com/lmconecta_?igsh=c2RvbGRpemU1MGk0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Instagram"
                  onClick={handleInstagramClick}
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="https://wa.me/5598986064394"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="WhatsApp"
                  onClick={handleWhatsAppClick}
                >
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>

            {/* COLUNA 2: LINKS RÁPIDOS */}
            <div className="footer-links-col">
              <h3>Links Rápidos</h3>
              <ul className="footer-links">
                <li>
                  <a
                    href="#servicos"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection("servicos");
                    }}
                  >
                    <i className="fas fa-chevron-right"></i> Serviços
                  </a>
                </li>
                <li>
                  <a
                    href="#contato"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection("contato");
                    }}
                  >
                    <i className="fas fa-chevron-right"></i> Contato
                  </a>
                </li>
                <li>
                  <a
                    href="#sobre"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection("sobre");
                    }}
                  >
                    <i className="fas fa-chevron-right"></i> Sobre Nós
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/lmconecta_?igsh=c2RvbGRpemU1MGk0"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="instagram-link-footer"
                  >
                    <i className="fas fa-chevron-right"></i> Portfólio
                  </a>
                </li>
              </ul>
            </div>

            {/* COLUNA 3: CONTATO */}
            <div className="footer-contato-col">
              <h3>Entre em Contato</h3>
              <div className="contato-info">
                <div className="contato-item">
                  <div className="contato-icon">
                    <i className="fab fa-whatsapp"></i>
                  </div>
                  <div className="contato-text">
                    <p>
                      <strong>WhatsApp</strong>
                    </p>
                    <a
                      href="https://wa.me/5598986064394"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="whatsapp-link-footer"
                      onClick={handleWhatsAppClick}
                    >
                      <i className="fab fa-whatsapp"></i> (98) 98606-4394
                    </a>
                  </div>
                </div>

                <div className="contato-item">
                  <div className="contato-icon">
                    <i className="fab fa-instagram"></i>
                  </div>
                  <div className="contato-text">
                    <p>
                      <strong>Instagram</strong>
                    </p>
                    <a
                      href="https://www.instagram.com/lmconecta_?igsh=c2RvbGRpemU1MGk0"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="instagram-link-footer"
                      onClick={handleInstagramClick}
                    >
                      @lmconecta_
                    </a>
                  </div>
                </div>

                <div className="contato-item">
                  <div className="contato-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className="contato-text">
                    <p>
                      <strong>Localização</strong>
                    </p>
                    <p>São Luís - MA</p>
                    <p style={{ fontSize: "0.85rem", marginTop: "5px" }}>
                      Atendemos em todo o Brasil
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* LINHA DIVISÓRIA COMPLETA */}
          <div className="footer-divider"></div>

          {/* RODAPÉ INFERIOR */}
          <div className="footer-bottom">
            <div className="footer-copyright">
              <p>
                &copy; {currentYear} LM Conecta - Soluções Digitais. Todos os
                direitos reservados.
              </p>
              <p>
                Desenvolvido por <strong>Lilia Rosa</strong>
              </p>
            </div>

            <div className="footer-extra-links">
              <a href="/politica-privacidade">Política de Privacidade</a>
              <a href="/mapa-site">Mapa do Site</a>
            </div>
          </div>
        </div>
      </footer>

      {/* BOTÃO VOLTAR AO TOPO */}
      <button
        className={`back-to-top ${showBackToTop ? "visible" : ""}`}
        onClick={scrollToTop}
        aria-label="Voltar ao topo"
      >
        <i className="fas fa-chevron-up"></i>
      </button>
    </>
  );
}
